import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { attachTransactionDrawerSchema } from './attach-transaction-drawer.schema';

export const useAttachTransactionForm = () =>
  useForm({
    resolver: yupResolver(attachTransactionDrawerSchema),
    defaultValues: attachTransactionDrawerSchema.cast({}),
  });
